import { Entorno } from './entorno.model';

const MAPBOX_TOKEN =
  'pk.eyJ1IjoiZXplcXVpZWxmYWxjb24iLCJhIjoiY2w0ZzF3d2s2MDJncjNjbzlhY3ppNDR4aSJ9.HbxnFpCClbHL5SOCI9BgSw';

const GOOGLE_CLIENT_ID = '784969237391-tnfgbeuu770irkhe2bss7vrspsvcquss.apps.googleusercontent.com';

// Los tres entornos, en un solo lugar: `environment.ts` elige uno a mano (como
// el `const env` de IRIX) y los archivos por configuración fijan el suyo.
//
// Son constantes **sueltas** y no un mapa a propósito: `environment.prod.ts`
// importa sólo `PROD`, y el build descarta las otras dos. Con un mapa, el
// bundle de producción llevaría adentro las URLs de test y de localhost.

export const PROD: Entorno = {
  urlIrix: 'https://irix.ar/main',
  nombre: 'prod',
  produccion: true,
  api: 'https://api.irix.ar/gestion-api-gestion',
  apiCron: 'https://api.irix.ar/gestion-cron',
  mapboxToken: MAPBOX_TOKEN,
  googleClientId: GOOGLE_CLIENT_ID,
};

export const TEST: Entorno = {
  urlIrix: 'https://irix.ar/main',
  nombre: 'test',
  produccion: false,
  api: 'https://api.irix.ar/gestion-api-gestion-test',
  apiCron: 'https://api.irix.ar/gestion-cron-test',
  mapboxToken: MAPBOX_TOKEN,
  googleClientId: GOOGLE_CLIENT_ID,
};

/**
 * Los backends corriendo en esta máquina. Los puertos son los que usan
 * `gestion-api-gestion` y `gestion-cron` cuando arrancan sin `.env`
 * (`PORT || 5004` y `PORT || 5001`), y **sin prefijo de ruta**: el prefijo
 * (`…-test`) lo pone el ingreso de los entornos desplegados, no el servidor
 * local.
 *
 * **CORS no hace falta tocarlo**: `gestion-api-gestion` llama a
 * `app.enableCors()` sin opciones, que refleja cualquier origen, y la sesión
 * viaja por headers (`Authorization` + `x-permiso`), no por cookies.
 */
export const LOCAL: Entorno = {
  urlIrix: 'http://localhost:4200/main',
  nombre: 'local',
  produccion: false,
  api: 'http://localhost:5004',
  apiCron: 'http://localhost:5001',
  mapboxToken: MAPBOX_TOKEN,
  googleClientId: GOOGLE_CLIENT_ID,
};
